import { produce } from '@/globals/helpers/immer';
import { useWebStorageStore } from '@/globals/webStorage/useWebStorage';
import { sessionStorageStore, defaultState } from '../state/accordionStore';
import { DispatchOpenedItems } from '../state/accordionStore.types';
import { accordionStateReducer } from '../state/accordionStateReducer';
import { useNavigationKey } from './useNavigationKey';
export const useAccordionReducer = (accordionKey: string) => {
  const navigationKey = useNavigationKey();
  const [allAccordionsState, setAllAccordionsState] = useWebStorageStore(sessionStorageStore, {});
  const accordionState = (navigationKey != null ? allAccordionsState?.[navigationKey]?.[accordionKey] : undefined) ?? defaultState;
  const dispatchOpenedItems: DispatchOpenedItems = action => {
    if (navigationKey == null) return;
    setAllAccordionsState(produce(draft => {
      const prevAccordionState = draft?.[navigationKey]?.[accordionKey] ?? defaultState;
      const newAccordionState = accordionStateReducer(prevAccordionState, action);
      if (draft == null) {
        return {
          [navigationKey]: {
            [accordionKey]: newAccordionState
          }
        };
      }
      draft[navigationKey] ??= {};
      draft[navigationKey][accordionKey] = newAccordionState;
    }));
  };
  return [accordionState, dispatchOpenedItems] as const;
};